import i18nFactory from '@yandex-int/i18n';

import * as keyset from './DuplicateHelper.i18n';

const i18n = i18nFactory(keyset);

export const getDuplicateSuccessMessage = (
    groupsIds: Array<string>,
    campaignsIds: Array<string>
): string => {
    const groupsIdsLength = groupsIds.length;
    const campaignsIdsLength = campaignsIds.length;

    if (groupsIdsLength === 1) {
        if (campaignsIdsLength > 1) {
            return i18n('noticeSingleGroupNoticeMessage', {
                id: groupsIds[0]
            });
        } else {
            return i18n('noticeSingleGroupSingleCampaignMessage', {
                id: groupsIds[0],
                campaignId: campaignsIds[0]
            });
        }
    } else if (campaignsIdsLength > 1) {
        return i18n('noticeMessageSuccess', {
            count: groupsIdsLength
        });
    } else {
        return i18n('noticeMessageSuccessOneCampaign', {
            campaignId: campaignsIds[0],
            count: groupsIdsLength
        });
    }
};
